import {useSelector} from 'react-redux';

import {getPaymentMethodsLoading} from 'desktop/pages/checkout/store/selectors/paymentStep/paymentStep';
import {
    getIsPrimerCreditCardLoading,
    getVaultedPaymentMethods,
} from 'desktop/pages/checkout/store/selectors/primer/primer';

/**
 * UsePrimerCreditCardState hook for getting loading states
 */
export const usePrimerCreditCardState = () => {
    const vaultedPaymentMethods = useSelector(getVaultedPaymentMethods);
    const isLoadingCreditCard = useSelector(getIsPrimerCreditCardLoading);
    const isLoadingPaymentMethods = useSelector(getPaymentMethodsLoading);

    const hasVaultedCards = vaultedPaymentMethods.length > 0;

    return {hasVaultedCards, isLoadingCreditCard, isLoadingPaymentMethods, vaultedPaymentMethods};
};
